import {
  GearIcon,
  IconButton,
  Popover,
  PopoverContent,
  type PopoverProps,
  PopoverTrigger,
  Portal,
} from '@frontend/legacy-components';

export type CustomizeViewProps = PopoverProps;

export const CustomizeView = ({
  children,
  ...restProps
}: CustomizeViewProps) => {
  return (
    <Popover size="sm" placement={'bottom-end'} {...restProps}>
      <PopoverTrigger>
        <IconButton size="lg">
          <GearIcon />
        </IconButton>
      </PopoverTrigger>
      <Portal>
        <PopoverContent>{children}</PopoverContent>
      </Portal>
    </Popover>
  );
};
